// Registro del service worker (PWA instalable). Sin Workbox: SW propio en public/sw.js.
// Solo en producción. Incluye auto-actualización: detecta una versión nueva desplegada y
// recarga la app sola (al volver a la pestaña o al pedirlo desde la UI).

let registration: ServiceWorkerRegistration | null = null;

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }
  window.addEventListener('load', () => {
    // ¿La página ya estaba controlada por un SW al cargar? Si sí, un cambio de controlador
    // = entró una versión nueva → recargamos. (En la 1ra instalación NO había controlador,
    // así que no recargamos de más.)
    const wasControlled = !!navigator.serviceWorker.controller;
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!wasControlled || reloaded) return;
      reloaded = true;
      window.location.reload();
    });

    const url = `${process.env.PUBLIC_URL}/sw.js`;
    navigator.serviceWorker
      .register(url)
      .then((reg) => {
        registration = reg;
      })
      .catch((err) => {
        console.error('SW registration failed:', err);
      });

    // Chequeo proactivo al volver a primer plano: si hay sw.js nuevo, el SW (con skipWaiting)
    // se activa y dispara controllerchange → recarga. Si no hay novedad, no pasa nada.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        registration?.update().catch(() => {});
      }
    });
  });
}

// Fuerza un chequeo de actualización (lo usa, por ej., el botón "Entendido" de los avisos).
export function checkForUpdate(): void {
  registration?.update().catch(() => {});
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
